import React from 'react';


const ShoppingPlusIcon = () => {
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" width="47" height="50" viewBox="0 0 47 50" fill="none">
        <path d="M12.5 4.1665L6.25 12.4998V41.6665C6.25 42.7716 6.68899 43.8314 7.47039 44.6128C8.25179 45.3942 9.3116 45.8332 10.4167 45.8332H39.5833C40.6884 45.8332 41.7482 45.3942 42.5296 44.6128C43.311 43.8314 43.75 42.7716 43.75 41.6665V12.4998L37.5 4.1665H12.5Z" stroke="#103A99" strokeWidth="4.16667" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6.25 12.5H43.75" stroke="#103A99" strokeWidth="4.16667" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M33.3337 20.8335C33.3337 23.0436 32.4557 25.1632 30.8929 26.7261C29.3301 28.2889 27.2105 29.1668 25.0003 29.1668C22.7902 29.1668 20.6706 28.2889 19.1078 26.7261C17.545 25.1632 16.667 23.0436 16.667 20.8335" stroke="#103A99" strokeWidth="4.16667" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      <svg xmlns="http://www.w3.org/2000/svg" width="23" height="50" viewBox="0 0 23 50" fill="none">
        <path d="M12.9863 5.62939V19.6294" stroke="#103A99" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5.98633 12.6294H19.9863" stroke="#103A99" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </>
  );
};

export default ShoppingPlusIcon;
